var map = {
	"./AC.svg": "0302",
	"./AD.svg": "d9f8",
	"./AE.svg": "906f",
	"./AF.svg": "da76",
	"./AG.svg": "11f5",
	"./AI.svg": "0d68",
	"./AL.svg": "b1e9",
	"./AM.svg": "cdb5",
	"./AO.svg": "9ccc",
	"./AQ.svg": "c0de",
	"./AR.svg": "ccc4",
	"./AS.svg": "0ac6",
	"./AT.svg": "9299",
	"./AU.svg": "6cbc",
	"./AW.svg": "c7e4",
	"./AX.svg": "46c3",
	"./AZ.svg": "dce3",
	"./BA.svg": "307d",
	"./BB.svg": "83ca",
	"./BD.svg": "7579",
	"./BE.svg": "0bc9",
	"./BF.svg": "2eff",
	"./BG.svg": "cb85",
	"./BH.svg": "5450",
	"./BI.svg": "a57a",
	"./BJ.svg": "e90c",
	"./BL.svg": "f54b",
	"./BM.svg": "a42a",
	"./BN.svg": "1cb5",
	"./BO.svg": "81f8",
	"./BQ.svg": "0f0f",
	"./BR.svg": "e24d",
	"./BS.svg": "ad64",
	"./BT.svg": "5e12",
	"./BV.svg": "0ffd",
	"./BW.svg": "bbcb",
	"./BY.svg": "ea34",
	"./BZ.svg": "681c",
	"./CA.svg": "35ab",
	"./CC.svg": "77fe",
	"./CD.svg": "55ae",
	"./CF.svg": "655b",
	"./CG.svg": "89da",
	"./CH.svg": "a118",
	"./CI.svg": "2381",
	"./CK.svg": "d539",
	"./CL.svg": "61b3",
	"./CM.svg": "3160",
	"./CN.svg": "517e",
	"./CO.svg": "092a",
	"./CR.svg": "f7c0",
	"./CU.svg": "f030",
	"./CV.svg": "3779",
	"./CW.svg": "c180",
	"./CX.svg": "2b04",
	"./CY.svg": "9471",
	"./CZ.svg": "75e4",
	"./DE.svg": "441d",
	"./DJ.svg": "ca65",
	"./DK.svg": "963f",
	"./DM.svg": "2c68",
	"./DO.svg": "4506",
	"./DZ.svg": "e246",
	"./EC.svg": "217a",
	"./EE.svg": "10e3",
	"./EG.svg": "952e",
	"./EH.svg": "6a01",
	"./ER.svg": "121e",
	"./ES.svg": "da41",
	"./ET.svg": "ce7d",
	"./FI.svg": "d0ed",
	"./FJ.svg": "af4d",
	"./FK.svg": "1832",
	"./FM.svg": "d2f4",
	"./FO.svg": "8d22",
	"./FR.svg": "a31b",
	"./GA.svg": "0909",
	"./GB.svg": "c1f1",
	"./GD.svg": "381b",
	"./GE-AB.svg": "40af",
	"./GE-OS.svg": "a5d2",
	"./GE.svg": "7b64",
	"./GF.svg": "41aa",
	"./GG.svg": "679b",
	"./GH.svg": "e810",
	"./GI.svg": "6339",
	"./GL.svg": "c209",
	"./GM.svg": "b3ae",
	"./GN.svg": "3559",
	"./GP.svg": "fd4e",
	"./GQ.svg": "bae7",
	"./GR.svg": "8448",
	"./GS.svg": "955c",
	"./GT.svg": "1341",
	"./GU.svg": "11d3",
	"./GW.svg": "633f",
	"./GY.svg": "bde3",
	"./HK.svg": "4a91",
	"./HM.svg": "6f4d",
	"./HN.svg": "7d68",
	"./HR.svg": "2e68",
	"./HT.svg": "15dd",
	"./HU.svg": "6b51",
	"./ID.svg": "0e44",
	"./IE.svg": "5870",
	"./IL.svg": "9935",
	"./IM.svg": "d63c",
	"./IN.svg": "0334",
	"./IO.svg": "d98c",
	"./IQ.svg": "0549",
	"./IR.svg": "cb05",
	"./IS.svg": "504b",
	"./IT.svg": "8593",
	"./JE.svg": "1d71",
	"./JM.svg": "f740",
	"./JO.svg": "8965",
	"./JP.svg": "39e5",
	"./KE.svg": "a883",
	"./KG.svg": "feca",
	"./KH.svg": "06dd",
	"./KI.svg": "1600",
	"./KM.svg": "7a42",
	"./KN.svg": "ceca",
	"./KP.svg": "8078",
	"./KR.svg": "a6e4",
	"./KW.svg": "68d2",
	"./KY.svg": "295d",
	"./KZ.svg": "f053",
	"./LA.svg": "bc24",
	"./LB.svg": "6f96",
	"./LC.svg": "c71d",
	"./LI.svg": "2b7e",
	"./LK.svg": "e982",
	"./LR.svg": "aa42",
	"./LS.svg": "4dff",
	"./LT.svg": "5f1a",
	"./LU.svg": "e858",
	"./LV.svg": "5a7e",
	"./LY.svg": "a2e2",
	"./MA.svg": "7fec",
	"./MC.svg": "113f",
	"./MD.svg": "5e3e",
	"./ME.svg": "b38a",
	"./MF.svg": "0b35",
	"./MG.svg": "13fc",
	"./MH.svg": "5132",
	"./MK.svg": "a8a9",
	"./ML.svg": "3d9d",
	"./MM.svg": "5b1a",
	"./MN.svg": "37b3",
	"./MO.svg": "cf46",
	"./MP.svg": "aa88",
	"./MQ.svg": "3d99",
	"./MR.svg": "b878",
	"./MS.svg": "5791",
	"./MT.svg": "a62d",
	"./MU.svg": "9df7",
	"./MV.svg": "d5a4",
	"./MW.svg": "e45d",
	"./MX.svg": "0b64",
	"./MY.svg": "8a0d",
	"./MZ.svg": "6748",
	"./NA.svg": "749f",
	"./NC.svg": "aac0",
	"./NE.svg": "b5ab",
	"./NF.svg": "287d",
	"./NG.svg": "9f19",
	"./NI.svg": "721d",
	"./NL.svg": "3b1e",
	"./NO.svg": "9c52",
	"./NP.svg": "bf29",
	"./NR.svg": "8930",
	"./NU.svg": "8855",
	"./NZ.svg": "a886",
	"./OM.svg": "ca74",
	"./PA.svg": "d26f",
	"./PE.svg": "7e7f",
	"./PF.svg": "2caf",
	"./PG.svg": "90de",
	"./PH.svg": "4086",
	"./PK.svg": "1a2a",
	"./PL.svg": "3949",
	"./PM.svg": "29ce",
	"./PN.svg": "111b",
	"./PR.svg": "183c",
	"./PS.svg": "390c",
	"./PT.svg": "6701",
	"./PW.svg": "200e",
	"./PY.svg": "ee76",
	"./QA.svg": "25c5",
	"./RE.svg": "5ba4",
	"./RO.svg": "e38e",
	"./RS.svg": "374a",
	"./RU.svg": "efbc",
	"./RW.svg": "4554",
	"./SA.svg": "7671",
	"./SB.svg": "358b",
	"./SC.svg": "9b59",
	"./SD.svg": "96d5",
	"./SE.svg": "2acf",
	"./SG.svg": "4bfd",
	"./SH.svg": "0e9d",
	"./SI.svg": "1cd1",
	"./SJ.svg": "c2cb",
	"./SK.svg": "e5a4",
	"./SL.svg": "8db5",
	"./SM.svg": "faad",
	"./SN.svg": "72f0",
	"./SO.svg": "7a5c",
	"./SR.svg": "3904",
	"./SS.svg": "0f4d",
	"./ST.svg": "c0e3",
	"./SV.svg": "8081",
	"./SX.svg": "3e91",
	"./SY.svg": "adea",
	"./SZ.svg": "1257",
	"./TA.svg": "6763",
	"./TC.svg": "1349",
	"./TD.svg": "d6be",
	"./TF.svg": "1e89",
	"./TG.svg": "c90f",
	"./TH.svg": "9769",
	"./TJ.svg": "a3bb",
	"./TK.svg": "b0f3",
	"./TL.svg": "9721",
	"./TM.svg": "93fb",
	"./TN.svg": "9271",
	"./TO.svg": "9eb0",
	"./TR.svg": "5493",
	"./TT.svg": "3caf",
	"./TV.svg": "ab87",
	"./TW.svg": "1aa6",
	"./TZ.svg": "66f8",
	"./UA.svg": "ca60",
	"./UG.svg": "ccb7",
	"./US.svg": "d31a",
	"./UY.svg": "7a0d",
	"./UZ.svg": "c168",
	"./VA.svg": "543e",
	"./VC.svg": "bfbe",
	"./VE.svg": "1d29",
	"./VG.svg": "a636",
	"./VI.svg": "0e4f",
	"./VN.svg": "28ae",
	"./VU.svg": "6ca8",
	"./WF.svg": "73b3",
	"./WORLD.svg": "0e26",
	"./WS.svg": "a3f0",
	"./XK.svg": "1eca",
	"./YE.svg": "a709",
	"./YT.svg": "4330",
	"./ZA.svg": "5ada",
	"./ZM.svg": "a6ec",
	"./ZW.svg": "da92"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "3511";